/**
 * Extrai a continuação da frase baseada no histórico de transcrições
 * @param {Array<{text: string}>} transcriptionHistory - Histórico de transcrições (objetos)
 * @param {Array} words - Array de palavras da frase original
 * @returns {string} Continuação da frase extraída
 */
export function extractContinuation(transcriptionHistory, words) {
  if (!transcriptionHistory || transcriptionHistory.length === 0) return "";
  if (!Array.isArray(words) || words.length === 0) return "";

  // Extrai texto dos objetos
  const transcriptionTexts = transcriptionHistory.map((t) => {
    if (typeof t === 'string') return t;
    if (t && typeof t.text === 'string') return t.text;
    return '';
  });
  const fullTranscription = transcriptionTexts.join(" ").toLowerCase();
  // const phrase = words.join(" ").toLowerCase();

  // Procura o índice da última palavra-alvo na transcrição
  const lastWordRaw = words[words.length - 1];
  if (typeof lastWordRaw !== 'string' || !lastWordRaw.trim()) {
    return "";
  }
  const lastWord = lastWordRaw.toLowerCase();
  const lastIndex = fullTranscription.lastIndexOf(lastWord);

  if (lastIndex === -1) {
    // se nunca falou a última palavra, não tem continuação ainda
    return "";
  }

  // Pega o trecho que vem depois da última palavra
  const continuation = fullTranscription.slice(lastIndex + lastWord.length).trim();

  return continuation;
}

